import { useMutation } from '@apollo/client/react';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useState } from 'react';

import {
  GetOrganizationNotificationSettingDocument,
  UpdateNotificationSettingDocument,
} from '~/graphql/generated/graphql';
import { settingsDrawerState } from '~/state/settings_systemsettings/atoms';

import { Fields } from './types';

export const useUpdateNotificationSetting = (organizationId?: string) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [update] = useMutation(UpdateNotificationSettingDocument, {
    refetchQueries: [{ query: GetOrganizationNotificationSettingDocument }],
  });

  const reset = useResetAtom(settingsDrawerState);

  const handleClose = useCallback(() => {
    reset();
  }, [reset]);

  const handleSubmit = useCallback(
    async (values: Fields) => {
      if (!organizationId) return;

      setIsUpdating(true);
      setError(null);

      const isTelEnabled = values.tel.enable === 'enabled';

      try {
        await update({
          variables: {
            input: {
              organizationId,
              data: {
                sound: {
                  enable: true,
                  interval: values.sound.interval || null,
                  name: values.sound.name,
                },
                tel: {
                  enable: isTelEnabled,
                  delay: values.tel.delay,
                  phoneNumber: isTelEnabled ? values.tel.phoneNumber : null,
                },
                medicationFollowupEnabled: values.medicationFollowup === 'enabled',
                onlineEnabled: values.online === 'enabled',
              },
            },
          },
        });
        handleClose();
      } catch (_error) {
        setError(_error?.message || 'エラーが発生しました');
      }

      setIsUpdating(false);
    },
    [handleClose, organizationId, update],
  );

  return {
    updating: isUpdating,
    error,
    handleClose,
    handleSubmit,
  };
};
